<template>
  <div id="OrgAccountInfo">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">企业账户信息</span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row">
          <div class="panel-body-row-left">注册电话：</div>
          <div class="panel-body-row-right">
            {{orgInfo.registerPhone}}
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">开户银行：</div>
          <div class="panel-body-row-right">
            {{orgInfo.openBank}}
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">银行账户:</div>
          <div class="panel-body-row-right">
            {{orgInfo.bankAccount}}
          </div>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
export default {
  name: 'OrgAccountInfo',
  components: {
    ebPanel,
    ebPanelHeader
  },
  props: {
    orgInfo: {}
  }
};
</script>
<style scoped lang="less">
</style>
